import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import { parseCsvCalendarDate } from '~/prix/utils/bulk/csvValueParsers'
import clearString from '~/prix/utils/bulk/clearString'

const medicalCertificate: Dataset = {
  schema: 'public_health',
  table: 'medical_certificate',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    attendance_original_id: original => original,
    icd10_code: original => original,
    description: original => original,
    absence_start_date: original => parseCsvCalendarDate(original as string),
    absence_days: original => (original != null && original !== '' ? Number(original) : null),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default medicalCertificate
